import { Injectable } from '@angular/core';
import { Question } from '@app/forms/subscription/definition/interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { ValidationBridgeService } from './validation-bridge.service';

import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';

@Injectable({
  providedIn: 'root',
})
export class CivilStatusQuestionsService {
  constructor(private cBService: ValidationBridgeService) {}
  civilstatusQustions: Question[] = [
    {
      name: 'email',
      template: 'email',
      title: 'Documents légaux',
      subTitle:
        'Nous avons besoin de votre accord afin de rendre votre contrat valide légalement.',
      type: 'owners',
      alwaysSkip: true,
      category: 'État civil',

      callbackValidation: (entity: PledgeRead) => {
        return entity?.owners?.[0]?.receivePreContractElementsEmail;
      },
      callbackBasedOn(pledge: PledgeRead) {
        return true;
      },
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'childrenForm',
      template: 'childrenForm',
      callbackValidation: entity => {
        return this.cBService.getChildrenForm(entity);
      },
      title: "Informations sur l'enfant mineur",
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.parameters?.additionalQuestions?.find(
          q => q.id == CompanyFieldType.CHILDREN_FORM,
        )
          ? true
          : false;
      },
      category: 'État civil',

      productType: ['ASSURANCE_VIE', 'SCPI'],
    },
    {
      name: 'civilState',

      template: 'civilState',

      callbackValidation: (entity, user) => {
        const isValid = this.cBService.getCivilState(entity, user);

        return isValid;
      },
      getTitle: (entity: PledgeRead) => {
        return entity.productType === 'PER'
          ? "Informations sur l'adhérent"
          : 'Informations sur le souscripteur';
      },
      type: 'owners',
      physicalUserOnly: true,

      category: 'État civil',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },

    {
      name: 'birthInfo',

      template: 'birthInfo',

      title: 'Quand et où êtes-vous né ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackValidation: (entity, user) => {
        return this.cBService.getBirthInfo(entity, user);
      },
      category: 'État civil',
      categoryId: 4,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'perSubscriberInfo',

      template: 'perSubscriberInfo',

      getTitle: (entity: PledgeRead) => {
        return entity.productType === 'PER'
          ? "Information complémentaires sur l'adhérent"
          : 'Information complémentaires sur les souscripteurs';
      },
      type: 'owners',
      physicalUserOnly: true,

      callbackValidation: (pledge: PledgeRead) => {
        return this.cBService.getPerSubscriberInfo(pledge);
      },
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.parameters?.additionalQuestions?.find(
          q => q.id == CompanyFieldType.RETIREMENT_AGE,
        )
          ? true
          : false;
      },
      category: 'État civil',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PER',
      ],
    },
    {
      name: 'address',
      template: 'address',
      callbackValidation: entity => {
        const isValid = this.cBService.getAddress(entity);

        return isValid;
      },
      title: 'Où habitez-vous ?',
      type: 'owners',
      physicalUserOnly: true,
      category: 'État civil',
      categoryId: 5,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'taxResidency',
      template: 'taxResidency',
      callbackValidation: entity => {
        return this.cBService.getTaxResidency(entity);
      },

      title: "Avez-vous d'autre(s) résidence(s) fiscale(s) hors France ?",
      subTitle:
        'La réglementation fiscale oblige à identifier les pays dans lesquels vous êtes identifié comme résident fiscal.',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'État civil',

      productType: [
        'ASSURANCE_VIE',
        'PER',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
      ],
    },
    {
      name: 'ownerTaxResidence',
      template: 'ownerTaxResidence',
      callbackValidation: (entity: PledgeRead) => {
        return this.cBService.getOwnerTaxResidence(entity);
      },
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      alwaysShow(entity: any, user) {
        return true;
      },
      showFirstTime: true,
      title: 'Quelle est votre résidence fiscale',
      type: 'owners',
      category: 'État civil',

      productType: [
        'PER',
        'ASSURANCE_VIE',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'phone',
      template: 'phone',
      callbackValidation: (entity, user) => {
        return this.cBService.getPhone(entity, user);
      },

      title: 'Comment vous contacter ?',
      subTitle:
        'Votre numéro de téléphone mobile vous permettra de réaliser votre signature électronique.',
      physicalUserOnly: true,
      category: 'État civil',

      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'otherInfo',

      template: 'otherInfo',
      callbackValidation: entity => {
        return this.cBService.getOtherInfo(entity);
      },
      title: 'Plus que quelques informations à propos de vous.',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'État civil',
      categoryId: 8,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
      ],
    },
    {
      name: 'maritalStatus',

      template: 'maritalStatus',

      callbackValidation: (entity, user) => {
        return this.cBService.getMaritalStatus(entity, user);
      },
      title: 'Quel est votre statut marital ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        if (pledge?.productType === 'PRESTATION') return false;
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'État civil',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'dependentChildren',

      template: 'dependentChildren',
      callbackValidation: entity => {
        return this.cBService.getDependentChildren(entity);
      },
      title: 'Avez-vous des enfants ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'État civil',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'personnesACharges',

      template: 'personnesACharges',
      callbackValidation: entity => {
        return this.cBService.getPersonnesACharges(entity);
      },
      title: 'Avez-vous des personnes à charge ?',
      type: 'owners',
      physicalUserOnly: true,
      callbackBasedOn(pledge: PledgeRead) {
        const { products = [] } = pledge || {};
        const hasSwisslifePartner = products.some(
          ({ parameters }) => parameters?.partnerFlux === 'SWISSLIFE',
        );

        if (!hasSwisslifePartner) return true;

        return !pledge?.owners?.[0]?.physicalUser;
      },
      category: 'État civil',
      productType: [],
    },
    {
      name: 'companyProfile',
      template: 'companyProfile',
      title: "Informations sur l'entreprise",
      type: 'owners',
      companyOnly: true,
      callbackBasedOn(pledge: PledgeRead, user: UserAuthentified) {
        if (pledge?.productType === 'PRESTATION' && user?.sessionConsultant)
          return false;
        return pledge?.owners?.[0]?.physicalUser;
      },
      callbackValidation: (entity, user: UserAuthentified) => {
        return this.cBService.getCompanyProfil(entity, user);
      },
      category: 'Entité morale',
      categoryId: 3,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },

    {
      name: 'companyAddresses',

      template: 'companyAddresses',
      title: "Informations sur l'adresse de l'entreprise",
      type: 'owners',
      companyOnly: true,
      callbackBasedOn(pledge: PledgeRead, user: UserAuthentified) {
        if (pledge?.productType === 'PRESTATION' && user?.sessionConsultant)
          return false;
        return pledge?.owners?.[0]?.physicalUser;
      },
      callbackValidation: entity => {
        return true;
        //  return this.cBService.getCompanyProfil(entity);
      },
      category: 'Entité morale',
      categoryId: 3,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'companySituationComptable',
      template: 'companySituationComptable',
      title: 'Informations situation comptable entreprise',
      type: 'owners',
      companyOnly: true,
      callbackBasedOn(pledge: PledgeRead, user: UserAuthentified) {
        if (pledge?.productType === 'PRESTATION' && user?.sessionConsultant)
          return false;
        return pledge?.owners?.[0]?.physicalUser;
      },
      callbackValidation: (entity, user: UserAuthentified) => {
        return this.cBService.getCompanySituationComptable(entity, user);
      },
      category: 'Entité morale',
      categoryId: 3,
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'companyBeneficialowner',
      template: 'companyBeneficialowner',
      callbackBasedOn(pledge: PledgeRead) {
        return pledge?.owners?.[0]?.physicalUser;
      },
      title: "Informations sur les bénéficiaires effectifs de l'entreprise",
      type: 'owners',
      category: 'Entité morale',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',

        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
  ];
}
